import { createTheme } from "@mui/material/styles";

// Shared MUI theme so every page (Login, LiveAttendanceLogin, GardView,
// AttendentCard, etc.) uses the same dark navy / blue palette as the
// NOCOPS Progress Monitor design.
const nocopsTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#3b82f6",
      light: "#60a5fa",
      dark: "#2563eb",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#06b6d4",
    },
    background: {
      default: "#0b1220",
      paper: "#141e33",
    },
    text: {
      primary: "#f1f5f9",
      secondary: "#94a3b8",
    },
    divider: "#24304a",
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "none", borderRadius: 10 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: "none" },
      },
    },
  },
});

export default nocopsTheme;
